import { BybButton } from "@Components/common/byb-ds";
import PositionConfig from "@Constants/game/position-config";
import { LightTooltip } from "@Components/generic";
import PlayPositions from "@Enums/PlayPositions";
import FootballField from "@Resources/game/tiles/football-field.png";
import { Box, useTheme } from "@mui/material";
import { useState } from "react";
import useI18n from "@i18n";
import { BybDialog } from "../common";
import { PositionSelectionButton } from "./styled-components";

// @ts-ignore
const defaultFlatPositionsList = [].concat(PositionConfig.goalkeeper, PositionConfig.defense, PositionConfig.midfield, PositionConfig.forward) as {
  id: PlayPositions;
  nameKey: string;
  fullnameKey: string;
  position: {
    top: string;
    right: string;
    left: string;
  };
}[];

interface IScenarioPositionsDialog {
  open: boolean;
  playPositions?: PlayPositions[];
  onApply: (playPositions: PlayPositions[]) => void;
  onClose: () => void;
}

const ScenarioPositionsDialog = ({ open, playPositions, onApply, onClose }: IScenarioPositionsDialog) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const [selectedPositions, setSelectedPositions] = useState<PlayPositions[]>(playPositions || []);

  const handlePositonClick = (position: PlayPositions, isSelected = false) => {
    if (isSelected) {
      const filtered = selectedPositions.filter((sp) => sp !== position);
      setSelectedPositions(filtered);
    } else {
      setSelectedPositions((prev) => [...prev, position]);
    }
  };

  const handleClose = () => {
    setSelectedPositions(playPositions || []);
    onClose();
  };

  const handleApply = () => {
    onApply(selectedPositions);
    onClose();
  };

  return (
    <BybDialog
      open={open}
      name="field-positions"
      title="Select field positions"
      onClose={handleClose}
      dialogActions={
        <>
          <BybButton onClick={handleClose} color="secondary" fullWidth>
            Cancel
          </BybButton>
          <BybButton onClick={handleApply} color="primary" fullWidth>
            Apply
          </BybButton>
        </>
      }
    >
      <Box
        sx={{
          position: "relative",
          height: theme.spacing(70),
          backgroundImage: `url(${FootballField})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {defaultFlatPositionsList.map((item) => {
          const isSelected = selectedPositions.includes(item.id);
          return (
            <LightTooltip key={item.id} title={i18n(item.fullnameKey)} enterDelay={300} leaveDelay={200} enterNextDelay={300}>
              <Box
                sx={{
                  position: "absolute",
                  translate: "-50% -50%",
                  top: item.position.top || undefined,
                  right: item.position.right || undefined,
                  left: item.position.left || undefined,
                }}
              >
                <PositionSelectionButton selected={isSelected} onClick={() => handlePositonClick(item.id, isSelected)}>
                  {i18n(item.nameKey)}
                </PositionSelectionButton>
              </Box>
            </LightTooltip>
          );
        })}
      </Box>
    </BybDialog>
  );
};

export default ScenarioPositionsDialog;
